import snakeCase from 'lodash/snakeCase';
import isObject from 'lodash/isObject';

export const convertObjectKeysToSnakeCase = (
  toTransform: Record<string, unknown> | Array<Record<string, unknown>> | any
) => {
  if (Array.isArray(toTransform)) return toTransform.map(array => convertObjectKeysToSnakeCase(array));
  if (isObject(toTransform)) {
    const results = {};
    Object.entries(toTransform).forEach(([key, val]) => {
      results[snakeCase(key)] = convertObjectKeysToSnakeCase(val);
    });
    return results;
  }
  // if not array and not object return the simple value back
  return toTransform;
};
